import React from 'react'
import ReactDOM from 'react-dom'
import amplitude, { amplitudeEvent } from 'util/amplitudeTrigger'
import createStore, { sagaMiddleware } from './store/createStore'

import { cardActionsSaga } from './modules/cardActions'
import { cardSaga } from './modules/card'
import { sagas as profileSagas } from './modules/profile'
import { sagas as userSagas } from './modules/user'
import { sagas as userContentSagas } from './modules/userContent'
import { sagas as commentsSagas } from './modules/comments'
import { sagas as modsSagas } from './modules/mods'
import {
  accountPicksSaga,
  pickCardSaga,
  checkUrlSaga,
  removePickSaga,
  pickExtractionSaga,
  saveExtractionSaga,
  checkExtractionStatusSaga
} from './modules/pick'
import { sagas as routerLocationsSagas } from './modules/routerLocations'
import { sagas as tagsSagas } from './modules/tags'
import { sagas as collectionSagas } from './modules/collection'
import { sagas as menusSagas } from './modules/menus'
import { sagas as searchSagas } from './modules/search'
import { sagas as advancedSearch } from './modules/advancedSearch'
import { sagas as feedsSagas } from './modules/feeds'
import { sagas as activitiesSagas } from './modules/activities'
import { sagas as viewSettingsSagas } from './modules/viewSettings'
import { readSettingsSaga, updateReadSettingsSaga } from './modules/readSettings'
import { processUserDataSaga } from './modules/cardUserData'
import { uploadImageSaga } from './modules/image'

import './styles/normalize.scss'
import './styles/main.scss'
import './styles/fonts/fonts.scss'

// Store Initialization
// ------------------------------------
const store = createStore(window.__INITIAL_STATE__)
;[
  ...[
    cardSaga,
    cardActionsSaga,
    accountPicksSaga,
    pickCardSaga,
    checkUrlSaga,
    removePickSaga,
    readSettingsSaga,
    updateReadSettingsSaga,
    processUserDataSaga,
    pickExtractionSaga,
    saveExtractionSaga,
    checkExtractionStatusSaga,
    uploadImageSaga
  ],
  ...viewSettingsSagas,
  ...modsSagas,
  ...profileSagas,
  ...userContentSagas,
  ...commentsSagas,
  ...searchSagas,
  ...advancedSearch,
  ...feedsSagas,
  ...activitiesSagas,
  ...routerLocationsSagas,
  ...tagsSagas,
  ...collectionSagas,
  ...menusSagas,
  ...userSagas
].forEach(saga => {
  sagaMiddleware.run(saga)
})

// Amplitude
amplitude('init', '3e22a5c9c23cd35308d92d99ca00a2b8')
localStorage.getItem('userData') && amplitude('setUserId', JSON.parse(localStorage.getItem('userData')).user.id)
amplitudeEvent('appLaunch')

// Version
try {
  localStorage.setItem('version', __VERSION__)
} catch (e) {
  // ignore
}

// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById('root')

let render = () => {
  const App = require('./components/App').default

  ReactDOM.render(<App store={store} />, MOUNT_NODE)
}

// Development Tools
// ------------------------------------
if (__DEV__) {
  if (module.hot) {
    const renderApp = render
    const renderError = error => {
      const RedBox = require('redbox-react').default

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE)
    }

    render = () => {
      try {
        renderApp()
      } catch (e) {
        console.error(e)
        renderError(e)
      }
    }

    // Setup hot module replacement
    module.hot.accept(['./components/App'], () =>
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE)
        render()
      })
    )
  }
}

// Let's Go!
// ------------------------------------
if (!__TEST__) render()
